import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_LOAD_FAILURE,
  PDF_LOAD_RETRY,
  PDF_LOAD_START,
  PDF_LOAD_SUCCEED,
} from '@app/libs/reactPdfJs/store/actionTypes';
import PDFLoadingStatus from '@app/libs/reactPdfJs/store/PDFLoadingStatus';

type PdfMaxScaleState = PDFLoadingStatus;

const initialState: PdfMaxScaleState = PDFLoadingStatus.IDLE;

export default function reducer(state: PdfMaxScaleState = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_LOAD_FAILURE:
      return PDFLoadingStatus.FAILED;
    case PDF_LOAD_RETRY:
    case PDF_LOAD_START:
      return PDFLoadingStatus.PENDING;
    case PDF_LOAD_SUCCEED:
      return PDFLoadingStatus.SUCCEEDED;
    default:
      return state;
  }
}
